import { Inject, Injectable } from "@angular/core";
import { catchError, map, Observable, of, tap } from "rxjs";
import ErrorsHandler from "./errors-handler";
import { Item } from "./models/item";
import IDisplayItems from "./ports/i-display-items";
import IManageItems from "./ports/i-manage-items";
import IManageMessages from "./ports/i-manage-messages"; 

@Injectable()
export default class ItemsDisplayer implements IDisplayItems {
    
    items: any;
    filter: string = '';
    
    constructor(
        private _errorHandler: ErrorsHandler,
        @Inject('IManageItems') private _itemsManager: IManageItems,
        @Inject('IManageMessages') private _messagesManager: IManageMessages,
    ) {}

    askItemsList(): Observable<void> {
        return this._itemsManager.getItems('TENARIS').pipe(
            tap(_ => this._messagesManager.add("fetched items")),
            catchError(this._errorHandler.handleError<Item>('getItems')),
            map(items => {this.items = items})
        );
    }

    askPaginatedItemsList(pageIndex: number = 1, pageSize: number = 10): Observable<void> {
        return this._itemsManager.getItemsPaged('TENARIS', pageIndex, pageSize).pipe(
            tap(_ => this._messagesManager.add("fetched paged items")),
            catchError(this._errorHandler.handleError<Item[]>('getItemsPaged')),
            map(items => { this.items = items; })
        );
    }
/*
    askHeroesFiltered(filter: string, allowEmpty: boolean = false): Observable<void> {
        if (!allowEmpty && !filter.trim()) {
            // if not filter string, return empty hero array.
            this.heroes = [];
            // avoid unexpected behaviours encountered using of()
            return of(null).pipe(map(_ => {}));
        }
        // in case allowEmpty is true, empty filter return all heroes
        return this._heroesManager.searchHeroes(filter).pipe(
            tap((heroes: Hero[]) => heroes.length ?
                this._messagesManager.add(`found heroes matching "${filter}"`) :
                this._messagesManager.add(`no heroes matching "${filter}"`)),
            catchError(this._errorHandler.handleError<Hero[]>('searchHeroes', [])),
            map(heroes => {this.heroes = heroes; this.filter = filter;})
        );
    }

    askHeroCreation(heroName: string): Observable<void> {
        heroName = heroName.trim();
        return this._heroesManager.addHero({name: heroName} as Hero).pipe(
            tap((newHero: Hero) => this._messagesManager.add(`added hero w/ id=${newHero.id}`)),
            catchError(this._errorHandler.handleError<Hero>('addHero')),
            map(hero => {
                if( hero === undefined){return;}
                if( heroName.indexOf(this.filter) !== -1){this.heroes.push(hero);}
            })
        );
    }
    
    askHeroDeletion(hero: Hero): Observable<void> {
        return this._heroesManager.deleteHero(hero.id).pipe(
            tap(_ => this._messagesManager.add(`deleted hero id=${hero.id}`)),
            catchError(this._errorHandler.handleError<Hero>('deleteHero', {id: -1} as Hero)),
            map(deletedHeroId => {this.heroes = this.heroes.filter(h => h.id !== deletedHeroId)})
        );
    }
*/
}